
import { defineComponent } from "vue";
import QQGroupQrCode from "@/assets/qq_group_qrcode.jpg";
import VueLogo from "@/assets/vue_logo.jpg";
import TsLogo from "@/assets/ts.jpeg";
import SpringLogo from "@/assets/spring_logo.svg";

export default defineComponent({
  setup() {
    return {
      QQGroupQrCode,
      VueLogo,
      TsLogo,
      SpringLogo
    };
  }
});
